import React from 'react';
import { Table, Button, Form, Badge } from 'react-bootstrap';

export function QuestionTable({ global = false, course, onEditQuestion, onDeleteQuestion, onAddQuestion }) {
  const questionsWithModule = Array.isArray(course?.sections)
    ? course.sections.flatMap(s => (s.questions || []).map(q => ({
        id: q.id,
        type: q.type,
        section: s.title,
        sectionId: s.id,
        text: q.text,
        tags: q.tags || [],
        fullQuestion: q, // Keep the full question object
      })))
    : [];

  const handleDuplicate = (question) => {
    const newQuestion = {
      ...question.fullQuestion,
      id: `question-${Date.now()}`,
      text: `${question.fullQuestion.text} (copy)`,
    };
    onEditQuestion?.(newQuestion, question.sectionId);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Form.Control size="sm" placeholder="Search questions" style={{ maxWidth: 320 }} />
        <div>
          <Button size="sm" variant="outline-secondary" className="me-2">Import</Button>
          <Button size="sm" variant="primary" onClick={() => onAddQuestion?.(course?.sections?.[0]?.id)}>+ New Question</Button>
        </div>
      </div>
      <Table hover responsive>
        <thead>
          <tr>
            {global && <th>Course</th>}
            <th>Section</th>
            <th>Type</th>
            <th>Text</th>
            <th>Tags</th>
            <th style={{ width: 260 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {questionsWithModule.length === 0 ? (
            <tr>
              <td colSpan={global ? 7 : 6} className="text-center text-muted py-4">
                No questions in this course
              </td>
            </tr>
          ) : (
            questionsWithModule.map(q => (
              <tr key={q.id}>
                {global && <td>{course?.title || ''}</td>}
                <td>{q.section}</td>
                <td><Badge bg="info">{q.type}</Badge></td>
                <td>{q.text}</td>
                <td>{q.tags.length > 0 ? q.tags.join(', ') : <span className="text-muted">—</span>}</td>
                <td>
                  <Button 
                    size="sm" 
                    variant="outline-primary" 
                    className="me-2" 
                    onClick={() => onEditQuestion?.(q.fullQuestion, q.sectionId)}
                  >
                    Edit
                  </Button>
                  <Button 
                    size="sm" 
                    variant="outline-secondary" 
                    className="me-2"
                    onClick={() => handleDuplicate(q)}
                  >
                    Duplicate
                  </Button>
                  <Button 
                    size="sm" 
                    variant="outline-danger" 
                    onClick={() => onDeleteQuestion?.(q.sectionId, q.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}
